/*============================================================================
  Product
==============================================================================*/

var product = {
  init: function(){
    var $productSection = $('.product_slider').parents('.product_section');
    var thumbnailPosition = $productSection.data('thumbnail');
    var slideshowAnimation = $productSection.data('slideshow-animation');
    var slideshowSpeed = $productSection.data('slideshow-speed');
    var $notify_form = $('.notify_form .contact-form');

    if (slideshowAnimation == 'zoom'){
      $('.image__container img', $productSection)
          .wrap('<div></div>')
          .parent()
          .zoom({
            magnify: 1
      });
    }

    var slider = $('.product_slider').flexslider({
      startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
      touch: true,
      pauseOnHover: true,
      controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
      directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
      animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
      slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
      slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
      start: function(slider){
        slider.resize();
      }
    });

    if($('.slides li:not(.clone)', $productSection).length == 1) {
      $('.flex-direction-nav', slider).hide();
    }

    $('.product_form.product_form_options.init').each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
      $('.product_form').addClass('is-visible');
      $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');

      });
    

  },
  unload: function($target){
    var slider = $target.find('.product_slider');
    destroySlider(slider);
  }
}

$(function() {
  product.init();
});